module.exports = __webpack_public_path__ + "static/pay-later-1-420312248ce574f6d8fd823d7d25d719.svg";